import Vue from 'vue'
import VueRouter from 'vue-router';
import { store } from '../store/store'
import Gallery from '@/components/Gallery.vue'
import Video from '@/components/Video.vue'
import Login from '@/components/login.vue'
import Profile from '@/components/profile.vue'
import Register from '@/components/Register.vue'
import Home from '@/components/Home.vue'
import About from "@/components/About.vue";
import Voucher from "@/components/Voucher.vue";
import Subscriptions from "@/components/Subscriptions.vue";
import AllArea from "@/components/AllArea.vue";
import ConfirmEmail from "@/components/ConfirmEmail.vue";
import PasswordResetRequest from "@/components/PasswordResetRequest.vue";
import PasswordResetSubmit from "@/components/PasswordResetSubmit.vue";
import Terms from "@/components/Terms.vue";
import Privacy from "@/components/PrivacyPolicy.vue";

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/', component: Home, name:'home'},
    { path: '/areas', component: AllArea, name:'areas'},
    { path: '/about', component: About, name:'about'},
    { path: '/terms', component: Terms, name:'terms'},
    { path: '/privacy', component: Privacy, name:'privacy'},
    { path: '/subscriptions', component: Subscriptions, name:'subscriptions'},
    { path: '/gallery', component: Gallery, name:'gallery'},
    { path: '/watched', component:Gallery, name:'watched',meta:{requiresAuth: true} },
    { path: '/voucher', component:Voucher, name:'voucher',meta:{requiresAuth: true} },
    { path: '/video/:id', component: Video, props:true, name:'video'},
    { path: '/confirm/:code/:token', component: ConfirmEmail, props:true, name:'confirmemail'},
    { path: '/login', component: Login, props:true,name:'login'},
    { path: '/register', component: Register,name:'register'},
    { path: '/reset-request', component: PasswordResetRequest,name:'password-reset-request'},
    { path: '/reset-submit/:code/:token', component: PasswordResetSubmit,name:'password-reset-submit', props:true},
    { path: '/profile', component: Profile, props:true, meta: {'requiresAuth': true}, name:'profile'},

  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!store.getters.loggedIn) {

      next({
        name: 'login',
        query :{redirect:to.path}
      })
    } else {
      next()
    }
  }
  else {
    next();
    }
  });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js